import { isPast } from 'date-fns';
import React, { useCallback, useEffect } from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { DateInput } from 'src/components/enterprise/components/DateInput/DateInput';

export interface ExpirationDateInputProps {
  id: string;
  name: string;
}

export const ExpirationDateInput: React.FC<ExpirationDateInputProps> = ({
  id,
  name,
}) => {
  const {
    errors,
    watch,
    control,
    setValue,
    formState: { dirtyFields },
  } = useFormContext();
  const date = watch('date');

  const resetValue = useCallback(() => {
    const isSynchronizeWithDate = dirtyFields.date && dirtyFields[name] && date;

    if (isSynchronizeWithDate) {
      setValue(name, null, { shouldValidate: true });
    }
  }, [dirtyFields, date, name, setValue]);

  useEffect(() => {
    resetValue();
  }, [resetValue]);

  return (
    <DateInput
      id={id}
      name={name}
      label="Deactivation date"
      control={control}
      error={errors[name]}
      rules={{
        required: 'Required',
      }}
      disabledDays={{
        before: !date || isPast(date) ? new Date() : date,
      }}
    />
  );
};
